export default {
    baseUrl: process.env.REACT_APP_BASE_URL,
    loginUrl: process.env.REACT_APP_LOGIN_URL,
    logoutUrl: process.env.REACT_APP_LOGOUT_URL,
}
